import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { CardKinds, CardTemplateDb } from '../redux/cardTemplateDbSlice';
import useCurrentUserId from './useCurrentUserId';

const useStandardCardTemplateDb = (kind: CardKinds) : [string | undefined, CardTemplateDb | undefined] => {
  const userId = useCurrentUserId();
  const ructs = useSelector((state: RootState) => state.relationUserCardTemplateDb).relationUserCardTemplates;
  const cardTemplates = useSelector((state: RootState) => state.cardTemplateDb).cardTemplates;

  const ructIds = Object.keys(ructs).filter(id => ructs[id].userId === userId);
  const idsByRuct = ructIds.map(id => ructs[id].cardTemplateId);
  const id = Object.keys(cardTemplates).find(id => {
    const target = cardTemplates[id];
    return idsByRuct.includes(id) && target.kind === kind;
  })
  const value = id ? cardTemplates[id] : undefined;

  return [id, value];
}

export default useStandardCardTemplateDb;
